import {
  Button,
  DropdownMenu,
  DropdownMenuPopover,
  DropdownMenuItemsLowLevel,
  DropdownMenuItem,
  DropdownMenuButton,
} from "gatsby-interface"
import * as React from "react"
import { positionRight } from "@reach/popover"
import { MdNotificationsNone } from "react-icons/md"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"

import {
  CloudResourceType,
  NotificationTransport,
  NotificationEventType,
} from "@modules/graphql/types"

import { getNotificationOptions, getNotificationDeploysLabel } from "./utils"
import { NotificationDeploysIcon } from "./NotificationDeploysIcon"
import { WebhookModal } from "./WebhookModal"
// import { EmailModal } from "./EmailModal"

export type NotificationDeploysTriggerProps = {
  resourceId: string
  resourceType: CloudResourceType
  children: React.ReactNode
}

export function NotificationDeploysTrigger({
  children,
  resourceType,
  resourceId,
}: NotificationDeploysTriggerProps) {
  const [selection, setSelection] = React.useState<string>()
  const notificationDeploysOptions = getNotificationOptions(resourceType)

  const handleModalClose = () => setSelection(undefined)

  return (
    <React.Fragment>
      <DropdownMenu>
        <Button
          rightIcon={<MdNotificationsNone />}
          ButtonComponent={DropdownMenuButton}
          variant="GHOST"
        >
          {children}
        </Button>

        <DropdownMenuPopover position={positionRight}>
          <DropdownMenuItemsLowLevel size="MAX_CONTENT">
            {notificationDeploysOptions.map(opt => (
              <DropdownMenuItem
                key={opt}
                onSelect={() => setSelection(opt)}
                css={{ display: "flex", alignItems: "center" }}
                Icon={props => (
                  <NotificationDeploysIcon type={opt} {...props} />
                )}
              >
                {getNotificationDeploysLabel(opt)}
              </DropdownMenuItem>
            ))}
          </DropdownMenuItemsLowLevel>
        </DropdownMenuPopover>
      </DropdownMenu>

      {/* Modal part */}
      <WebhookModal
        isOpen={selection === NotificationTransport.OutgoingWebhook}
        onClose={handleModalClose}
        transport={NotificationTransport.OutgoingWebhook}
        label={notificationDeploysText.labels.webhooks}
        ariaLabel={notificationDeploysText.labels.addWebhookDeployNotification}
        resourceId={resourceId}
        resourceType={resourceType}
        inputLabel={notificationDeploysText.labels.outgoingWebhooks}
        inputHint={notificationDeploysText.messages.webhookHint}
      />

      <WebhookModal
        isOpen={selection === NotificationTransport.SlackWebhook}
        onClose={handleModalClose}
        transport={NotificationTransport.SlackWebhook}
        label={notificationDeploysText.labels.slack}
        ariaLabel={notificationDeploysText.labels.addSlackDeployNotification}
        resourceId={resourceId}
        resourceType={resourceType}
        inputLabel={notificationDeploysText.labels.outgoingWebhooks}
        inputHint={notificationDeploysText.messages.webhookSlackHint}
      />

      <WebhookModal
        isOpen={selection === NotificationTransport.PullRequestComment}
        onClose={handleModalClose}
        transport={NotificationTransport.PullRequestComment}
        label={notificationDeploysText.labels.prComment}
        ariaLabel={
          notificationDeploysText.labels.addPullRequestCommentDeployNotification
        }
        resourceId={resourceId}
        resourceType={resourceType}
        specificEvents={[
          NotificationEventType.BuildSucceeded,
          NotificationEventType.BuildFailed,
        ]}
      />

      {/* <EmailModal isOpen={selection === "email"} onClose={handleModalClose} /> TODO: email is not available in lib graphql for now */}
    </React.Fragment>
  )
}
